import { Component, OnDestroy, OnInit } from '@angular/core';
import { APIService } from 'src/app/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifierService } from 'src/app/services/notifier.service';
import { getENV } from 'src/app/_helpers/helpers';
import { Subscription } from 'rxjs';
interface Kit {
  id: number;
  KitID: string;
  VenueState: string;
  CodeType: string;
  Jurisdiction?: string;  // Added this line
}

@Component({
  selector: 'app-operator-kit-management',
  templateUrl: './operator-kit-management.component.html',
  styleUrls: ['./operator-kit-management.component.css'],
})
export class OperatorKitManagementComponent implements OnInit, OnDestroy {
  kits: Kit[] = [];
  config: any;
  groupedKits: { 
    [codeType: string]: { 
      [venueState: string]: {
        [jurisdiction: string]: Kit[]
      }
    }
  } = {};
  selectedKit: string = null;

  constructor(
    private apiService: APIService,
    private router: ActivatedRoute,
    private navigator: Router,
    private notifier: NotifierService
  ) {
    this.config = this.router.snapshot.data['config'];
  }

  querySubscription: Subscription;

  ngOnInit(): void {
    this.fetchKits();
    this.querySubscription = this.router.queryParams.subscribe((params) => {
      if (params['kit']) {
        this.selectedKit = params['kit'];
      } else {
        this.selectedKit = null;
      }
    });
  }

  ngOnDestroy(): void {
    this.querySubscription.unsubscribe();
  }

  selectKit(kit: string): void {
    this.navigator.navigate(['/dash/operator-kit-management'], {
      queryParams: { kit: kit },
    });
  }

  hideKit() {
    this.navigator.navigate(['/dash/operator-kit-management']);
  }

  // Add this method to the component class
  async onTestButtonClick(): Promise<void> {
    console.log('Test API button was clicked!');
    
    let apiURL: string = `${
      this.config[getENV()].raceAPI
    }/asset-trigger`;

    let header: any = {
      'X-Api-Key': 'e2bvuAoslY1VJvFMqhr5x7nxoEhFVRii9jRngS3U',
    };

    let result: any = await this.apiService.postDataPromis(apiURL, {}, header);
    if (result.status === 1 && result.message === "Success") {
      this.notifier.alert('Info', '', 'Operation completed successfully', 'info', 5000);
    } else {
      this.notifier.alert('Info', '', 'Operation failed', 'info', 5000);
    }
    console.log(result);
    // this.notifier.alert('Success', '', 'Generating PDF...', 'success', 5000);
  }

  async fetchKits(): Promise<void> {
    let apiURL: string = `${this.config[getENV()].raceAPI}/devices/kit_ids`;
    let response = await this.apiService.getDataPromis(apiURL, {}, {});
    console.log(response);
    this.kits = response.data;

    this.groupKits();
    //   this.http.get<{ data: Kit[] }>('https://4otldh9um5.execute-api.ap-southeast-2.amazonaws.com/tsd-prd-api/devices/kit_ids')
    //     .subscribe(response => {
    //       this.kits = response.data;
    //       this.groupKits();
    //       console.log(this.groupedKits);
    //     });
  }

  groupKits(): void {
    // First, deduplicate kits by KitID while keeping the latest entry
    const uniqueKits = this.kits.reduce((acc: { [kitId: string]: Kit }, kit) => {
      acc[kit.KitID] = kit;
      return acc;
    }, {});

    // Convert back to array and perform grouping
    this.groupedKits = Object.values(uniqueKits).reduce((acc: { 
      [codeType: string]: { 
        [venueState: string]: {
          [jurisdiction: string]: Kit[]
        } 
      } 
    }, kit) => {
      // Use 'Other' for null or undefined CodeType
      const codeType = kit.CodeType || 'Other';
      // Use 'Unassigned' for null or undefined VenueState
      const venueState = kit.VenueState || 'Unassigned';
      // Use 'Unassigned' for null or undefined Jurisdiction
      const jurisdiction = kit.Jurisdiction || 'Unassigned';
      
      // Initialize the CodeType object if it doesn't exist
      if (!acc[codeType]) {
        acc[codeType] = {};
      }
      
      // Initialize the VenueState object if it doesn't exist
      if (!acc[codeType][venueState]) {
        acc[codeType][venueState] = {};
      }

      // Initialize the Jurisdiction array if it doesn't exist
      if (!acc[codeType][venueState][jurisdiction]) {
        acc[codeType][venueState][jurisdiction] = [];
      }
      
      // Add the kit to the appropriate group
      acc[codeType][venueState][jurisdiction].push(kit);
      
      // Sort kits within each Jurisdiction by KitID
      acc[codeType][venueState][jurisdiction].sort((a, b) => a.KitID.localeCompare(b.KitID));
      
      return acc;
    }, {});

    // Sort CodeTypes alphabetically
    const sortedGroupedKits: typeof this.groupedKits = {};
    Object.keys(this.groupedKits)
      .sort()
      .forEach(codeType => {
        sortedGroupedKits[codeType] = {};
        // Sort VenueStates alphabetically within each CodeType
        Object.keys(this.groupedKits[codeType])
          .sort()
          .forEach(venueState => {
            sortedGroupedKits[codeType][venueState] = {};
            // Sort Jurisdictions alphabetically within each VenueState
            Object.keys(this.groupedKits[codeType][venueState])
              .sort()
              .forEach(jurisdiction => {
                sortedGroupedKits[codeType][venueState][jurisdiction] = 
                  this.groupedKits[codeType][venueState][jurisdiction];
              });
          });
      });
    
    this.groupedKits = sortedGroupedKits;
  }
}
